<script lang="ts" setup>
  import Popup from '@shared/components/popup.vue'

  defineProps<{
    isShownPopup: boolean
    snapshot: string
  }>()

  const emit = defineEmits(['close'])

  const close = () => {
    emit('close')
  }
</script>

<template>
  <popup :is-show="isShownPopup" class="tw-max-w-[1145px] tw-w-auto tw-max-h-[740px] tw-h-full" @close="close">
    <template #body>
      <div class="tw-mb-16">
        <img :src="snapshot" class="tw-h-[610px] tw-object-contain tw-mx-auto" />
      </div>
    </template>
  </popup>
</template>
